/** 풀블리드 레이아웃 templateStyle / 레지스트리 키 공통 정의 (React·레이아웃과 분리) */
export const LEAD_GEN_FULLBLEED_STYLE_PREFIX = 'lead-gen-fullbleed'

export function leadGenFullbleedTemplateStyleForCategory(categoryCode) {
  return `${LEAD_GEN_FULLBLEED_STYLE_PREFIX}__${categoryCode}`
}

export function isLeadGenFullbleedLayoutKey(key) {
  return (
    key === LEAD_GEN_FULLBLEED_STYLE_PREFIX
    || (typeof key === 'string' && key.startsWith(`${LEAD_GEN_FULLBLEED_STYLE_PREFIX}__`))
  )
}
